import React from 'react';
import { StockChart, Tabs } from '@components';

function tabComp(props) {
  const {
    formatCurrency,
    buyerName,
    targetName,
    selectedRange,
    changeRange,
    data: { buyer, target },
    onChange,
    defaultValue,
    ...rest
  } = props;

  return (
    <Tabs
      className="stock-tab-wrapper"
      defaultValue={defaultValue}
      onChange={onChange}
      // destroyInactiveTabPane={true}
      tabs={[
        {
          label: buyerName || '-',
          children: (
            <div>
              <StockChart
                formatCurrency={formatCurrency}
                data={buyer}
                onRangeSelected={changeRange}
                selected={selectedRange}
                {...rest}
              />
            </div>
          ),
        },
        {
          label: targetName || '-',
          children: (
            <StockChart
              formatCurrency={formatCurrency}
              data={target}
              onRangeSelected={changeRange}
              selected={selectedRange}
              {...rest}
            />
          ),
        },
      ]}
    />
  );
}

export default tabComp;
